<ng-container *ngIf="isUrl$ | async; else checkHtml">
   <ng-container *ngIf="isSecure$ | async; else notSecure">
      <iframe
         [ngClass]="(isWindowDraggedOrResized$ | async) ? 'sam-cursor-disabled' : ''"
         [src]="url$ | async"
         allow="{{ allowAttributes$ | async }}"
      >
      </iframe>
   </ng-container>
</ng-container>
<ng-template #notSecure>
   <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin fa-layers">
      <label>{{ 'brick.brick_definitions.web_viewer.not_secure' | translate }}</label>
   </div>
</ng-template>

<ng-template #checkHtml>
   <ng-container *ngIf="htmlCode$ | async; else noValue">
      <iframe [ngClass]="(isWindowDraggedOrResized$ | async) ? 'sam-cursor-disabled' : ''" [srcdoc]="htmlCode$ | async">
      </iframe>
   </ng-container>
</ng-template>

<ng-template #noValue>
   <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin fa-layers">
      <fa-icon [icon]="slashIcon" size="3x" transform="shrink-2 "></fa-icon>
      <fa-icon [icon]="globeIcon" size="3x"></fa-icon>
   </div>
</ng-template>
